<!-- new theme implementation starts -->
<div class="subheader with-padding flgrow">
  <div class="row">
    <div class="col-lg-3 col-md-6 col-sm-8">
      <div class="relative flmid">
        <div class="flgrow">
          <div class="input-group">
            <input class="form-control" type="text" name="searchTerm" placeholder="{{ 'lblSearch' | translate }}"
            [(ngModel)]="pService.searchTerm" autocomplete="off" />
            <div class="input-group-append">
              <button type="button" class="btn btn-primary">
                <em class="fa fa-search"></em>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-auto ml-auto" *ngIf="userRoleRightsDetails.canAdd">
      <button type="button" type="reset" class="add-button btn btn-primary" aria-label="Center Align" (click)="onAdd()"
        translate>lblAddMechanicTimeCode</button>
    </div>
  </div>
</div>

<div class="container prel">
  <div class="row">
    <div class="c12">
      <div class="card mb-3">
        <div class="card-header d-flex" translate>
            lblMechanicTimeCode
        </div>
        <div class="table-responsive">
        <table class="tablest1">
          <thead>
            <tr>
              <th style="width: 55px" scope="col">#</th>
              <th scope="col" translate>lblTimeCode</th>
              <th scope="col" translate>lblDealerName</th>
              <th scope="col" translate>lblDescription</th>
              <th scope="col" class="text-center" sortable="isShowInDWO" (sort)="onSort($event)" translate>lblShowInDWO</th>
              <th style="width: 75px" scope="col" class="text-center" translate>lblAction</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="mechanicTimeCodeList?.length>0; else load_else">
              <tr *ngFor="let timeCode of mechanicTimeCodeList; let i=index">
                <td>{{ timeCode.rowNumber }}</td>
                <td>
                  <ngb-highlight [result]="timeCode.timeCode" [term]="pService.searchTerm">
                  </ngb-highlight>
                </td>
                <td>
                  <ngb-highlight [result]="timeCode.dealerName" [term]="pService.searchTerm">
                  </ngb-highlight>
                </td>
                <td>
                  <ngb-highlight [result]="timeCode.description" [term]="pService.searchTerm">
                  </ngb-highlight>
                </td>
                <td class="text-center">
                  <em class="fas" [ngClass]="{'fa-check': timeCode.isShow, 'fa-close': !timeCode.isShow}"></em>
                </td>
                <td class="nowrap text-center">
                  <a class="btn btn-ico" ngbTooltip="{{'lblEdit' | translate}}" tooltipClass="custom-revert" (click)="onEdit(timeCode.id)" *ngIf="userRoleRightsDetails.canEdit">
                    <em class="fas fa-pencil-alt fa-lg"></em>
                  </a>
                </td>

              </tr>
            </ng-container>
            <ng-template #load_else>
              <tr>
                <td colspan="6" class="no-record" translate>lblNoRecordsFound</td>
              </tr>
            </ng-template>
          </tbody>
        </table>
        </div>
        <div class="card-footer">
          <div class="d-flex justify-content-between">
            <div class="d-flex justify-content-between">
              <ngb-pagination [collectionSize]="pService.total$  | async" [(page)]="pService.page"
                [pageSize]="pService.pageSize" [maxSize]="3">
              </ngb-pagination>
              <select class="custom-select mx-2" style="width: auto" name="pageSize" [(ngModel)]="pService.pageSize">
                <option *ngFor="let item of pService.pageItemsArray" [ngValue]="item.values" translate>{{item.label}}
                </option>
              </select>
            </div>
            <div class="d-flex justify-content-between p-2 font17 fontbold" style="margin: auto 0;">
              <span class="font17 fontnormal" translate>lblTotal</span>:&nbsp;{{pService.total$  | async}}&nbsp;<span class="font17 fontnormal" translate>lblResults</span>
            </div>
    
          </div>
        </div>

      </div>
      
    </div>
  </div>

</div>
<!-- new theme implementation ends -->
